export default class Category {

  /**
   * @param id GUID of this category.
   * @param name 
   * @param description 
   * @param userId ID of the user to which this category belongs to. If null, this category doesn't belong to any user and is a system default one.
   */
  constructor(
    public id: string | undefined,
    public name: string,
    public description: string,
    public userId: string | undefined
  ) { }

  /**
   * Returns wheter this category is a user custom made one. Otherwise it is a system default category.
   * @returns True if this category is user custom made.
   */
  isUserCustom(): boolean {
    return this.userId != null;
  };
}